import * as Yup from 'yup';

const fields = {
  email: Yup.string().email('Invalid email address').required('Required'),
  password: Yup.string()
    .min(6, 'Must be 6 characters or more')
    .max(16, 'Must be 16 characters or less')
};

export default {
  login: Yup.object({
    email: fields.email,
    password: fields.password.required('Required')
  }),

  createUser: Yup.object({
    email: fields.email.required('Required'),
    password: fields.password.required('Required'),
    confirmPassword:Yup.string()
    .test('passwords-match', 'Passwords must match', function(value){
      return this.parent.password === value
    })
    /*
    confirmPassword: Yup.string().when('password', {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Passwords don't match")
    }),*/
  }),

  editUser: Yup.object({
    email: fields.email,
    password: fields.password
  })
};
